import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useDataGrid } from '../../../hooks/DataGrid';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useDataGridWidget = () => {
    const { components } = useDataGrid({
        rows: [{ name: 'Object', id: 0 }],
        columns: [{ field: 'name', headerName: 'Name' }],
        checkboxSelection: true,
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "DataGrid" }), components.DataGrid] })), [components]);
    return {
        name: 'useDataGrid',
        category: 'hooks',
        component,
    };
};
